import { Instance, types } from 'mobx-state-tree'

export const AiStore = types
  .model({
    isRefreshTotalInfo: types.maybeNull(types.boolean),
    isRefreshMemberList: types.maybeNull(types.boolean),
    isRefeshPreviewData: types.maybeNull(types.boolean),
    isResetSelectProduct: types.maybeNull(types.boolean),
    isAgain: types.maybeNull(types.boolean),
  })
  .actions(self => {
    const setIsRefreshTotalInfo = (val: boolean) => {
      self.isRefreshTotalInfo = val
    }

    const setIsRefreshMemberList = (val: boolean) => {
      self.isRefreshMemberList = val
    }

    const setIsRefeshPreviewData = (val: boolean) => {
      self.isRefeshPreviewData = val
    }

    const setIsResetSelectProduct = (val: boolean) => {
      self.isResetSelectProduct = val
    }

    const setIsAgain = (val: boolean) => {
      self.isAgain = val
    }

    return {
      setIsRefreshTotalInfo,
      setIsRefreshMemberList,
      setIsRefeshPreviewData,
      setIsResetSelectProduct,
      setIsAgain,
    }
  })
export type IAiStore = Instance<typeof AiStore>
